module.exports = __webpack_public_path__ + "resources/img/img_speech_to_text2.f0d3c2bb4a044ef3e3914334ee54154a.png";